/* Кадр разового фото (bot-dance.js cropBox, cropCss, BotCore.frameSize): рамка в пропорциях ролика, сдвиг и приближение снимка. */
export interface MotionCropValue {
  cx: number;
  cy: number;
  z: number;
}
export const CROP_CY = 0.42;
const BOX = { w: 280, h: 300 };
export function frameSize(ratio: number, box = BOX) {
  const r = Number.isFinite(ratio) && ratio > 0 ? ratio : 9 / 16;
  return r >= box.w / box.h ? { w: box.w, h: Math.round(box.w / r) } : { w: Math.round(box.h * r), h: box.h };
}
/** Размер и сдвиг снимка в долях рамки пропорций fa (bot-dance.js cropBox): центр не выводит рамку за снимок. */
export function cropBox(image: { w: number; h: number }, fa: number, c: MotionCropValue) {
  const ia = (image.w || 3) / (image.h || 4),
    z = c.z || 1;
  const wP = (ia > fa ? ia / fa : 1) * z,
    hP = (ia > fa ? 1 : fa / ia) * z;
  const hx = 0.5 / wP,
    hy = 0.5 / hP;
  const cx = Math.min(1 - hx, Math.max(hx, c.cx)),
    cy = Math.min(1 - hy, Math.max(hy, c.cy));
  return { wP, hP, cx, cy, l: 0.5 - cx * wP, t: 0.5 - cy * hP };
}
export function cropStyle(image: { w: number; h: number }, fa: number, c: MotionCropValue) {
  const b = cropBox(image, fa, c),
    p = (x: number) => `${(x * 100).toFixed(2)}%`;
  return { position: 'absolute' as const, maxWidth: 'none', width: p(b.wP), height: p(b.hP), left: p(b.l), top: p(b.t) };
}
